import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { sendNotification } from "../api/plan";
import { SHOW_SNACKBAR } from "../utils/types";
import { generateTokenByApiKey } from "../api/login";
import { getEmailBody } from "../utils/helper";

const Contact = () => {
  const [notification, setNotification] = useState({});
  let dispatch = useDispatch();

  const onSendEmail = (e) => {
    e.preventDefault();
    const { name, email, phone, subject, message } = notification;
    const emailBody = getEmailBody(name, email, phone, message);

    const request = {
      notificationType: "EMAIL",
      from: process.env.REACT_APP_SENDER_EMAIL,
      subject: subject || "Contact Form Submission",
      toUsers: {
        [process.env.REACT_APP_TO_EMAIL]: {
          email: process.env.REACT_APP_TO_EMAIL
        }
      },
      body: emailBody
    };
    dispatch(
      generateTokenByApiKey(
        {},
        "zealthix",
        {
          "x-tenant-id": process.env.REACT_APP_TENANT_ID,
          "X-Api-Key": process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
        },
        (t) => {
          if (t.access_token) {
            dispatch(sendNotification(request, t.access_token, a => {
              e.target.reset();
              setNotification({});
              dispatch({
                type: SHOW_SNACKBAR,
                payload: {
                  type: "error",
                  message: "Email sent successfully",
                  open: true,
                },
              });
            }))
          }
        }
      )
    );
  }

  return (
    <section id="h4-pricing" className="relative w-full overflow-hidden">
      {/* breadcrumb start */}
      <section id="h1-breadcrumb z-10">
        <div className="h1-breadcrumb w-full h-fit overflow-hidden relative breadcrumbImg pb-16 md:pb-24">
          <div className="theme-container mx-auto h-fit w-fit relative z-10">
            <div className="mt-[120px] md:mt-[172px] w-fit mx-auto relative z-10">
              <h1 className="px-5 py-2 border border-[#AF493E20] text-[#AF493E] font-medium rounded-[30px] w-fit mx-auto">
                Have Questions?
              </h1>
              <h1 className="text-main-black mt-4 text-34 sm:text-48 font-semibold w-full text-center">
                Contact Information
              </h1>
            </div>
          </div>
        </div>
      </section>
      {/* breadcrumb end */}

      <section
        className="w-full py-16 md:py-[130px] max-md:pt-[20px]"
        data-aos="fade"
      >
        <div className="theme-container mx-auto w-fulltext-black">
          <div className="grid grid-cols-6 md:grid-cols-12 items-center">
            <div className="col-span-6">
              <div className="contact-style-one-info md:pr-[200px]">
                <ul className="md:!mt-0">
                  <li className="md:!mt-0">
                    <img
                      className="mr-4"
                      src="assets/images/phone.svg"
                      alt=""
                      style={{ width: "60px" }}
                    />
                    <div className="content">
                      <h5 className="title">Hotline</h5>
                      <a
                        href="tel:9214562942"
                        className="text-[16px] !font-medium!text-black"
                      >
                        tel:+91-9214562942
                      </a>
                    </div>
                  </li>
                  <li>
                    <img
                      className="mr-4"
                      src="assets/images/location.svg"
                      alt=""
                      style={{ width: "60px" }}
                    />
                    <div className="info">
                      <h5 className="title">Our Location</h5>
                      <p className="!font-medium!text-black">
                        Kabir Nagar, Durgakund, Varanasi, Uttar Pradesh - 221005
                      </p>
                    </div>
                  </li>
                  <li>
                    <img
                      className="mr-4"
                      src="assets/images/email.svg"
                      alt=""
                      style={{ width: "60px" }}
                    />
                    <div className="info">
                      <h5 className="title">Official Email</h5>
                      <a
                        href="mailto:support@carenova.in"
                        className="text-[16px] !font-medium!text-black"
                      >
                        support@carenova.in
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-span-6">
              <div class="border border-purple/10 bg-[#FEF9F6] rounded-[10px] p-4 md:p-[50px] max-md:mt-[80px]">
                <h1 class="text-[30px] tracking-tight font-semibold text-main-black pb-6">
                  Send Us Message
                </h1>
                <p class="text-paragraph mb-[30px]">
                  All fields are required.
                </p>
                <form onSubmit={onSendEmail}
                  action="#"
                  class="grid grid-cols-6 md:grid-cols-12 gap-[30px]"
                >
                  <input
                    type="text" value={notification?.name}
                    required onChange={(e) => setNotification({ ...notification, name: e.target.value })}
                    placeholder="Full Name"
                    class="col-span-6 h-[30px] focus:outline-none border-b border-purple/10 focus:border-purple bg-transparent"
                  />
                  <input
                    type="email" value={notification?.email}
                    required onChange={(e) => setNotification({ ...notification, email: e.target.value })}
                    placeholder="Email Id"
                    class="col-span-6 h-[30px] focus:outline-none border-b border-purple/10 focus:border-purple bg-transparent"
                  />
                  <input
                    type="tel" value={notification?.phone}
                    required onChange={(e) => setNotification({ ...notification, phone: e.target.value })}
                    placeholder="Phone Number"
                    class="col-span-6 h-[30px] focus:outline-none border-b border-purple/10 focus:border-purple bg-transparent"
                  />
                  <input
                    type="text" value={notification?.subject}
                    required onChange={(e) => setNotification({ ...notification, subject: e.target.value })}
                    placeholder="Subject"
                    class="col-span-6 h-[30px] focus:outline-none border-b border-purple/10 focus:border-purple bg-transparent"
                  />
                  <textarea value={notification?.message || ""}
                    required onChange={(e) => setNotification({ ...notification, message: e.target.value })}
                    placeholder="Message"
                    class="col-span-6 md:col-span-12 focus:outline-none border-b border-purple/10 focus:border-purple bg-transparent h-[83px]"
                  ></textarea>

                  <div class="col-span-6 md:col-span-12">
                    <button class="home-two-btn-bg py-3 group bg-[#af493e] border-[#af493e] inline-flex">
                      <span class="text-base text-white group-hover:text-[#af493e] transition-all duration-300 font-inter relative z-10">
                        Send Message
                      </span>
                      <svg
                        class="relative z-10"
                        width="7"
                        height="12"
                        viewBox="0 0 7 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          class="group-hover:stroke-[#af493e] transition-all duration-300"
                          d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default Contact;
